// eslint-disable-next-line no-unused-vars
import { DevicePhoneMobileIcon, Battery50Icon, PhotoIcon, MapIcon, BoltIcon, FireIcon, KeyIcon, ServerIcon, SignalIcon, HashtagIcon, LightBulbIcon, MapPinIcon, XMarkIcon, Bars3Icon, Squares2X2Icon, BarsArrowUpIcon, BarsArrowDownIcon, Bars4Icon, SunIcon, NoSymbolIcon } from '@heroicons/vue/24/solid';

export const DEFAULT_FIREWORK_IMAGE = 'https://cdn-icons-png.flaticon.com/512/258/258036.png';

export const SORT_DIRECTIONS = Object.freeze({
	ASC: 'ascending',
	DESC: 'descending',
	CRON: 'chronological',
});

export const SHOW_TYPES = Object.freeze({
	PYRO: { key: 'pyro', label: 'Pyro Only' },
	PYRO_DMX: { key: 'pyro_dmx', label: 'Pyro & DMX' },
	DMX: { key: 'dmx', label: 'DMX Only' },
});

export const SHOW_EQUIPMENT_MANUFACTURES = Object.freeze({
	COBRA: { key: 'COBRA', label: 'COBRA Firing Systems', short_label: 'COBRA' },
	IGNITE: { key: 'IGNITE', label: 'IGNITE Firing Systems', short_label: 'IGNITE' },
});

export const EVENT_TYPES = Object.freeze({ PYRO: 'pyro', DMX: 'dmx' });

export const BAR_HEIGHT_CONVERSIONS = Object.freeze({ 1: 6, 2: 7, 3: 8, 4: 9, 5: 10, 6: 11, 7: 12, 8: 13, 9: 14, 10: 15 });
export const BAR_HEIGHT_CONVERSIONS_BACK = Object.freeze({ 6: 1, 7: 2, 8: 3, 9: 4, 10: 5, 11: 6, 12: 7, 13: 8, 14: 9, 15: 10 });

export const DEFAULT_WAVEFORM_COLORS = Object.freeze({
	cue_marker_color: '#000000',
	waveform_color: '#36383a',
	waveform_progress_color: '#8A2E89',
	waveform_background_color: '#718096',
	waveform_playhead_color: '#EE5864',
});

export const EVENT_EDIT_METHODS = Object.freeze({ custom: 'custom', shift_events: 'shift_events', add_to_previous_duration: 'addToPreviousDuration', step: 'step', alternate: 'alternate', alternate1: 'alternate1', alternate2: 'alternate2' });

export const STANDARD_EVENT_KEYS = Object.freeze({
	'event_time': 'Good',
	'event_time_in_seconds': 'Good',
	'universe': 'Good',
	'channel': 'Good',
	'cue': 'Good',
	'firework_name': 'Good',
	'duration': 'Good',
	'duration_in_seconds': 'Good',
	'igniter_pre_fire': 'Good',
	'igniter_pre_fire_in_seconds': 'Good',
	'lift_time': 'Good',
	'lift_time_in_seconds': 'Good',
	'isSTEP': 'Good',
	'isALTERNATE1': 'Good',
	'isALTERNATE2': 'Good',
	'time_before_step': 'Good',
	'comment': 'Good',
	'pulse': 'Good',
	'timeline_event_time': 'Good',
});

export const SHOW_TYPES_BY_EVENTS = Object.freeze({ TIMED: 'timed', STEP: 'step', COMPOUND: 'compound', BLANK: 'blank' });

export const DURATION_TRIGGER_REASON = Object.freeze({ EVENT_TIME_FIRING: 'EVENT_TIME_FIRING', PRE_FIRE_FIRING: 'PRE_FIRE_FIRING', LIFT_TIME_FIRING: 'LIFT_TIME_FIRING' });
export const ADD_EVENT_BUTTON_STATES = Object.freeze({ PYRO: 'PYRO', STEP: 'STEP', DMX: 'DMX' });

export const AUTO_ADDRESS_APPLY_TO_TARGETS = Object.freeze({ SELECTED_EVENTS: 'selected_events', ENTIRE_SHOW: 'entire_show', THIS_POSITION: 'this_position' });

export const SEVERITY = Object.freeze({
	TRIVIAL: { key: 'TRIVIAL', label: 'Trivial' },
	MINOR: { key: 'MINOR', label: 'Minor' },
	MAJOR: { key: 'MAJOR', label: 'Major' },
	TWEAK: { key: 'TWEAK', label: 'Tweak' },
});

export const REPRODUCIBILITY = Object.freeze({
	CONSISTENT: { key: 'CONSISTENT', label: 'Every Time' },
	INTERMITTENT: { key: 'INTERMITTENT', label: 'Sometimes' },
	RANDOM: { key: 'RANDOM', label: 'Random' },
	UNSURE: { key: 'UNSURE', label: 'Unsure' },
	ONCE: { key: 'ONCE', label: 'Only once' },
});

export const EVENT_TABLE_COLUMNS = Object.freeze({
	ROW_NUMBER: 0,
	EVENT_TIME: 1,
	CHANNEL: 2,
	CUE: 3,
	EVENT_DESCRIPTION: 4,
	QUANTITY: 9,
	DURATION: 5,
	PRE_FIRE: 6,
	LIFT_TIME: 7,
	COMMENT: 7,
	PULSE: 8,

	UNIVERSE: 15,
	EVENT_TYPE: 20,

	EVENT_CATEGORY: 21,
});

export const ERROR_MESSAGES = {
	NON_PYRO_SHOW: 'non pyro show',
	NON_DMX_SHOW: 'non dmx show',
};

// Maps the `type` field on event errors/warnings (set by addIssueToEvent/addIssueToArray, called from validateEvents in eventsHelper.js) to a short, human readable label key for the export errors modal.
export const EVENT_ISSUE_TYPE_LABELS = Object.freeze({
	channel_empty: 'export_show.error_types.channel_empty',
	cue_empty: 'export_show.error_types.cue_empty',
	universe_empty: 'export_show.error_types.universe_empty',
	channel_NaN: 'export_show.error_types.channel_nan',
	cue_NaN: 'export_show.error_types.cue_nan',
	universe_NaN: 'export_show.error_types.universe_nan',
	not_valid_channel: 'export_show.error_types.not_valid_channel',
	not_valid_cue: 'export_show.error_types.not_valid_cue',
	not_valid_universe: 'export_show.error_types.not_valid_universe',
	not_valid_dmx_value: 'export_show.error_types.not_valid_dmx_value',
	not_valid_pulse_value: 'export_show.error_types.not_valid_pulse_value',
	pulse_NaN: 'export_show.error_types.pulse_nan',
	duration_NaN: 'export_show.error_types.duration_nan',
	pre_fire_NaN: 'export_show.error_types.pre_fire_nan',
	lift_time_NaN: 'export_show.error_types.lift_time_nan',
	same_cue: 'export_show.error_types.same_cue',
	within_2_seconds: 'export_show.error_types.within_2_seconds',
	negative_calcualted_event_time: 'export_show.error_types.negative_event_time',
	semicolon: 'export_show.error_types.semicolon',
});

export const EVENT_ISSUE_TYPE_LABEL_FALLBACK = 'export_show.error_types.other';

export const IGNITE_CHANNEL_COLORS = Object.freeze({
	0: { key: 0, channel: 0, label: 'Red', background_color_hex_value: '#F96364', border_color_hex_value: '#d01818' },
	1: { key: 1, channel: 1, label: 'Yellow', background_color_hex_value: '#FDF270', border_color_hex_value: '#d4cb42' },
	2: { key: 2, channel: 2, label: 'Green', background_color_hex_value: '#ACF66A', border_color_hex_value: '#37cb2b' },
	3: { key: 3, channel: 3, label: 'Teal', background_color_hex_value: '#8BFDF4', border_color_hex_value: '#3fc5bc' },
	4: { key: 4, channel: 4, label: 'Blue', background_color_hex_value: '#70B3FF', border_color_hex_value: '#487CE4' },
	5: { key: 5, channel: 5, label: 'Pink', background_color_hex_value: '#F932F6', border_color_hex_value: '#a20092' },
});

export const WIDGETS_NAMES = Object.freeze({ fireworks: 'fireworks', dmx: 'dmx', show_details: 'show_details' });

export const SHOW_SOURCE = Object.freeze({ CSC: 'CSC', IGNITE: 'IGNITE' });

export const ENVIRONMENTS = Object.freeze({
	// PRODUCTION: { key: 'PRODUCTION', label: 'Stable', is_primary: true, visible_to_user: true, host: 'studio.elevatepyro.com' },
	PRODUCTION: { key: 'PRODUCTION', label: 'Stable', is_primary: true, visible_to_user: true, host: 'cobrashowcreator.com' },
	// BETA: { key: 'BETA', label: 'BETA', is_primary: false, visible_to_user: true, host: 'beta.studio.elevatepyro.com' },
	BETA: { key: 'BETA', label: 'BETA', is_primary: false, visible_to_user: true, host: 'beta.cobrashowcreator.com' },
	ALPHA: { key: 'ALPHA', label: 'Alpha', is_primary: false, visible_to_user: false, host: 'alpha.studio.elevatepyro.com' },
	STAGING: { key: 'STAGING', label: 'Staging', is_primary: false, visible_to_user: false, host: 'staging.studio.elevatepyro.com' },
	DEVELOPMENT: { key: 'DEVELOPMENT', label: 'Dev', is_primary: false, visible_to_user: false, host: 'development.studio.elevatepyro.com' },
});

export const SHOW_METHODS = Object.freeze({
	addNewEvent: 'addNewEvent',
	makeComment: 'makeComment',
	makeEventChanges: 'makeEventChanges',
	insertEventAboveOrBelow: 'insertEventAboveOrBelow',
	deleteEvent: 'deleteEvent',
	duplicateEvent: 'duplicateEvent',
	eventFireworkChanged: 'eventFireworkChanged',
	updateEventDuration: 'updateEventDuration',
	updateEventPreFire: 'updateEventPreFire',
	updateEventLiftTime: 'updateEventLiftTime',
	updateEventPulseTime: 'updateEventPulseTime',
	updateShowForInsertedDmx: 'updateShowForInsertedDmx',
	updateEventDescription: 'updateEventDescription',
	updateEventUniverse: 'updateEventUniverse',
	updateEventQuantity: 'updateEventQuantity',
	updateEventDefinedPosition: 'updateEventDefinedPosition',
	updateEventDisableFiringGroup: 'updateEventDisableFiringGroup',
	pasteEvent: 'pasteEvent',
});

export const SHOW_ORDER_STATUES = Object.freeze({
	DESIGNING: { key: 'DESIGNING', id: 1, label: 'Designing', tailwind_bg_color_class: 'bg-gray-600', tailwind_border_color_class: 'border-gray-600' },
	RESERVED: { key: 'RESERVED', id: 2, label: 'Reserved', tailwind_bg_color_class: 'bg-indigo-600', tailwind_border_color_class: 'border-indigo-600' },
	ASSIGNED: { key: 'ASSIGNED', id: 3, label: 'Assigned', tailwind_bg_color_class: 'bg-yellow-500', tailwind_border_color_class: 'border-yellow-500' },
	// PICKING: { key: 'PICKING', id: 5, label: 'Picking', tailwind_bg_color_class: 'bg-orange-500', tailwind_border_color_class: 'border-orange-500' }, //hiding this status for now
	PACKED: { key: 'PACKED', id: 6, label: 'Packed', tailwind_bg_color_class: 'bg-purple-600', tailwind_border_color_class: 'border-purple-600' },
	FIRED: { key: 'FIRED', id: 4, label: 'Fired', tailwind_bg_color_class: 'bg-red-600', tailwind_border_color_class: 'border-red-600' },
	CANCELED: { key: 'CANCELED', id: 7, label: 'Cancelled', tailwind_bg_color_class: 'bg-green-600', tailwind_border_color_class: 'border-green-600' },
});

export const PRODUCT_TYPES = Object.freeze({ STANDARD: 'STANDARD', UPGRADE: 'UPGRADE' });
export const PRODUCTS = Object.freeze({ CSC: 'CSC', CSC_LEGACY: 'CSC_LEGACY', CP: 'CP', INVENTORY_UPGRADE: 'INVENTORY_UPGRADE', CSC_EQP_UPG: 'CSC_EQP_UPG', CSO: 'CSO' });
export const RECURRING_INTERVALS = Object.freeze({ MONTHLY: 'MONTHLY', YEARLY: 'YEARLY', WEEKLY: 'WEEKLY', DAILY: 'DAILY' });
export const SUBSCRIPTION_TYPES = Object.freeze({ LIFETIME: 'LIFETIME', RECURRING: 'RECURRING', ONE_TIME: 'ONE_TIME' });

export const COBRA_FIRMWARE_VERSIONS = Object.freeze({
	2.1: { key: 2.1, label: '2.1' },
	3: { key: 3, label: '3.0' },
	4: { key: 4, label: '4.0', is_beta: true },
	5: { key: 5, label: '5.0', is_beta: true },
	5.1: { key: 5.1, label: '5.1', is_default: true },
	6: { key: 6, label: '6.0', is_beta: true, hide_unless_already_selected: true },
	6.1: { key: 6.1, label: '6.1' },
	7: { key: 7, label: '7.0', is_beta: true, hide_unless_already_selected: true },
	7.1: { key: 7.1, label: '7.1', is_beta: true, hide_unless_already_selected: false },
	8.0: { key: 8.0, label: '8.0', is_beta: true },
});

export const DISABLE_GROUP_COLORS_HEX = ['#bec2c8', '#95a2b3', '#5e6ad2', '#26b5ce', '#4cb782', '#f2c94c', '#f2994a', '#f7c8c1', '#eb5757'];

export const COLUMN_KEYS = { EVENT_TIME: 'event_time', CHANNEL: 'channel', CUE: 'cue', DESCRIPTION: 'description', QUANTITY: 'quantity', DURATION: 'duration', PRE_FIRE: 'igniter_pre_fire', LIFT_TIME: 'lift_time', EVENT_TYPE: 'event_type', UNIVERSE: 'universe', PULSE: 'pulse', CUSTOM_COLUMNS: 'custom_columns', IS_STEP: 'is_step', DISABLE_FIRING_GROUP: 'disable_firing_group' };
export const column_key_for_index = { 'event_time': 0, 'channel': 1, 'cue': 2, 'description': 3, 'duration': 4, 'igniter_pre_fire': 5, 'lift_time': 6 };
export const event_object_keys_for_column_key = { event_time: 'event_time', channel: 'channel', cue: 'cue', description: 'firework_name', quantity: 'quantity', duration: 'duration', igniter_pre_fire: 'igniter_pre_fire', lift_time: 'lift_time', universe: 'universe', pulse: 'pulse' };
export const alternate_column_for_main_column_key = { 'duration': 'duration_in_seconds', 'igniter_pre_fire': 'igniter_pre_fire_in_seconds', 'lift_time': 'lift_time_in_seconds' };
export const column_index_for_key = { 0: 'event_time', 1: 'channel', 2: 'cue', 3: 'description', 4: 'duration', 5: 'igniter_pre_fire', 6: 'lift_time' };
// Frozen snapshots of the two maps above, captured before pasteEvent can mutate them, so they can be reset before every paste.
export const DEFAULT_COLUMN_KEY_FOR_INDEX = Object.freeze({ ...column_key_for_index });
export const DEFAULT_COLUMN_INDEX_FOR_KEY = Object.freeze({ ...column_index_for_key });

export const IN_SECONDS_COLUMNS = [
	{
		in_seconds_key: 'duration_in_seconds',
		column_key: 'duration',
	},
	{
		in_seconds_key: 'igniter_pre_fire_in_seconds',
		column_key: 'igniter_pre_fire',
	},
	{
		in_seconds_key: 'lift_time_in_seconds',
		column_key: 'lift_time',
	},
];

export const LOAD_FIREWORK_LIMIT = 100;

export const LOAD_DMX_EFFECT_LIMIT = 100;

export const HARDWARE_DEVICE_NAMES = {
	'SIX_M': '6M',
	'EIGHTEEN_M': '18M',
	'THIRTY_SIX_M_MAIN': '36M',
	'SEVENTY_TWO_M_MAIN': '72M',
	'NINETY_M_MAIN': '90M',
	'AUDIOBOX': 'Audiobox',
};

export const HARDWARE_UPDATE_MESSAGES = {
	ONE_MODULE_UPDATED: 'event:modules.one_updated',
	MODULES_UPDATED: 'event:modules.updated',
	DEVICE_INFO_UPDATED: 'event:controller.device_info_updated',
	DEVICE_STATUS_UPDATED: 'event:controller.device_status_updated',
	CONTROLLER_CONNECTED: 'event:controller.connected',
	CONTROLLER_DISCONNECTED: 'event:controller.disconnected',
	CURRENT_SESSION_SWITCHED: 'event:session.current_session_switched',
};

export const MODULE_TYPES = {
	EIGHTEEN_M: 'EIGHTEEN_M',
	NINETY_M_MAIN: 'NINETY_M_MAIN',
	NINETY_M_SUB: 'NINETY_M_SUB',
	SEVENTY_TWO_M_MAIN: 'SEVENTY_TWO_M_MAIN',
	SEVENTY_TWO_M_SUB: 'SEVENTY_TWO_M_SUB',
	FIFTY_FOUR_M_MAIN: 'FIFTY_FOUR_M_MAIN',
	FIFTY_FOUR_M_SUB: 'FIFTY_FOUR_M_SUB',
	THIRTY_SIX_M_MAIN: 'THIRTY_SIX_M_MAIN',
	THIRTY_SIX_M_SUB: 'THIRTY_SIX_M_SUB',
	AUDIOBOX: 'AUDIOBOX',
	AUDIOBOX_MISSING: 'AUDIOBOX_MISSING',
	WSQP: 'WSQP',
	SIX_M: 'SIX_M',
	MISSING_M: 'MISSING_M',
};

export const SIGNAL_STRENGTH_INDICATOR = {
	GOOD: 55,
	BAD: 75,
};

export const BATTERY_STRENGTH_INDICATOR = {
	GOOD: 7,
	BAD: 4,
};

export const KEY_POSITION = {
	ARM: 'ARM',
	TEST: 'TEST',
};

export const FIRING_MODE = {
	CLIP_ON: 'CLIP_ON',
	EMATCH: 'EMATCH',
};

export const FIRING_MODE_DISPLAY_NAMES = {
	CLIP_ON: 'Clip-on',
	EMATCH: 'eMatch',
};

export const CONTINUITY_STATUS = {
	NOT_IN_SCRIPT: 'NOT_IN_SCRIPT',
	UNUSED: 'UNUSED',
	MISSING: 'MISSING',
	IGNORED: 'IGNORED',
	GOOD: 'GOOD',
	MULTIPLE_STATES: 'MULTIPLE_STATES',
};

export const MODULE_VOLTAGE_MODES = {
	MODULE_9V: 'MODULE_9V',
	MODULE_12V: 'MODULE_12V',
	MODULE_14_8V: 'MODULE_14_8V',
	MODULE_18V: 'MODULE_18V',
	MODULE_24V: 'MODULE_24V',
};

export const MODULE_VOLTAGE_MODE_DISPLAY_NAMES = {
	MODULE_9V: '9V',
	MODULE_12V: '12V',
	MODULE_14_8V: '14.8V',
	MODULE_18V: '18V',
	MODULE_24V: '24V',
};

export const COBRA_18R2_MODES = {
	TEST: 'TEST',
	ARM: 'ARM',
};
export const SMPTE_TIMECODE_TYPES = Object.freeze({
	TIMECODE1: 'timecode1',
	TIMECODE2: 'timecode2',
	BLANK: 'blank',
});

export const AVAILABLE_MODULE_SEARCH_TYPES = [
	{ id: 'device_type', label: 'Device Type', icon: DevicePhoneMobileIcon },
	{ id: 'channel', label: 'Channel', icon: HashtagIcon },
	{ id: 'address', label: 'Address', icon: MapIcon },
	{ id: 'event_description', label: 'Event Description', icon: Bars4Icon },
	{ id: 'position', label: 'Position', icon: MapPinIcon },
	{ id: 'disable_firing_group', label: 'Disable Firing Group', icon: NoSymbolIcon },
];
export const LABELS_SORT_BY = Object.freeze({
	EVENT_TIME: {
		label: 'Event Time',
		value: 'event_time_in_seconds',
		key: 'event_time',
	},
	CHANNEL: {
		label: 'Channel',
		value: 'channel',
		key: 'channel',
	},
	FIREWORK_NAME: {
		label: 'Event Description',
		value: 'firework_name',
		key: 'event_description',
	},
	CUE: {
		label: 'Cue',
		value: 'cue',
		key: 'cue',
	},
	DURATION: {
		label: 'Duration',
		value: 'duration_in_seconds',
		key: 'duration',
	},
	DESCRIPTION: {
		label: 'Description',
		value: 'description',
		key: 'description',
	},
	NAME: {
		label: 'Name',
		value: 'name',
		key: 'name',
	},
	BRAND: {
		label: 'Brand',
		value: 'manufacturer',
		key: 'manufacturer',
	},
	NUMBER_OF_SHOTS: {
		label: 'Shots',
		value: 'number_of_shots',
		key: 'number_of_shots',
	},
	PART_NUMBER: {
		label: 'Part Number',
		value: 'part_number',
		key: 'part_number',
	},
	CATEGORY: {
		label: 'Category',
		value: 'category',
		key: 'category',
	},
	POSITION: {
		label: 'Position',
		value: 'defined_position',
		key: 'defined_position',
	},
});

export const LABELS_SORT_BY_GROUPS = Object.freeze({
	EVENT_DATA: {
		key: 'event_data',
		label: 'Event Data',
	},
	FIREWORK_DATA: {
		key: 'firework_data',
		label: 'Firework Data',
	},
	CUSTOM_COLUMNS: {
		key: 'custom_columns',
		label: 'Custom Columns',
	},
});

export const PLACEHOLDER_TEXT_KEYS = Object.freeze({
	FIREWORK_DATA: 'firework_data',
	EVENT_DATA: 'event_data',
	COLUMN_DATA: 'column_data',
	SHOW_DATA: 'show_data',
	POSITION: 'defined_position',
});

export const PERSIST_EVENT_LABEL_STATE = Object.freeze({
	OPEN_EDIT_LABEL_MODAL: 'is_editing_template',
	OPEN_EVENT_LABEL_TEMPLATES_MODAL: 'selected_event_label_template',
});

export const PAGE_SIZE_OPTIONS = [
	{
		label: 'US letter',
		value: '1',
		width: 8.5,
		height: 11,
	},
	{
		label: 'A4',
		value: '2',
		width: 8.27,
		height: 11.69,
	},
	{
		label: 'Custom',
		value: '3',
		width: 8.5,
		height: 11,
	},
];

export const DPI = 96;

export const MY_FIREWORKS_CATEGORIES = {
	'manufacturer': 'Brand',
	'category': 'Category',
	'part_number': 'Part Number',
	'duration': 'Duration',
	'lift_time': 'Lift Time',
	'number_of_shots': 'Shots',
	'available_inventory': 'Available Inventory',
	'cost': 'Cost',
	'qty_in_show': 'Qty in Show',
};

export const IDLE_TIMEOUT = 1800;

export const SAVE_TRIGGERED_FROM = Object.freeze({
	OFFLINE_SYNC: 'OFFLINE_SYNC',
	SIDEBAR_BUTTON: 'SIDEBAR_BUTTON',
	AUTO_SAVE: 'AUTO_SAVE',
	OFFLINE_SYNC_FORCE_SAVE: 'OFFLINE_SYNC_FORCE_SAVE',
	FORCE_SAVE: 'FORCE_SAVE',
	SHORTCUT_SAVE: 'SHORTCUT_SAVE',
	IDLE_SAVE: 'IDLE_SAVE',
});
// eslint-disable-next-line no-useless-escape
export const VALID_CHARACTERS_REGEX_FOR_SCRIPT_NAME = /^[^\s]([0-9a-zA-Z\-\_ ])+$/;
// eslint-disable-next-line no-useless-escape
export const INVALID_CHARACTERS_REGEX_FOR_SCRIPT_NAME = /[^0-9a-zA-Z\-\_ ]/g; // characters that aren't digits, letters, hyphens, underscores, or spaces.

export const LAYOUTS = Object.freeze({
	EDITOR: { key: 'EDITOR', label: 'Editor' },
	OPERATOR_DEVICES: { key: 'OPERATOR_DEVICES', label: 'Devices' },
	OPERATOR_CONTROLS: { key: 'OPERATOR_CONTROLS', label: 'Controls' },
});

export const AVAILABLE_EVENTS_LIST_SEARCH_TYPES = [
	{ id: 'dmx_universe', label: 'DMX Universe', icon: NoSymbolIcon },
	{ id: 'channel', label: 'Channel', icon: HashtagIcon },
	{ id: 'event_description', label: 'Event Description', icon: Bars4Icon },
	{ id: 'position', label: 'Position', icon: MapPinIcon },
	{ id: 'disable_firing_group', label: 'Disable Firing Group', icon: NoSymbolIcon },
];
export const METHOD_TO_EDIT_TIME = {
	MANUAL_EDIT_EVENT_MODAL: 'MANUAL_EDIT_EVENT_MODAL',
	DRAGGING_ON_WAVEFORM: 'DRAGGING_ON_WAVEFORM',
	SHIFT_FOR_SELECTED_EVENTS: 'SHIFT_FOR_SELECTED_EVENTS',
	DELAY_AFTER_PREVIOUS_EVENT_ENDS: 'DELAY_AFTER_PREVIOUS_EVENT_ENDS',
	EDIT_RELATIVE_EVENT_TIME: 'EDIT_RELATIVE_EVENT_TIME',
	STEP_EVENT_RECALCULATED: 'STEP_EVENT_RECALCULATION',
};

export const MAX_NUMBER_OF_FREE_TIER_EVENTS = 36;
